import styled from "styled-components";

export const RequisitionNameWrapper = styled.div`
  color: ${({ theme }) => theme.greyMedium};
  text-align: left;
  user-select: all;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  position: relative;
  gap: 8px;

  & > div > svg {
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }
`;

export const RequisitionActionBar = styled.div`
  visibility: hidden;
  justify-content: flex-end;
  flex-shrink: 0;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  max-width: 120px;
  margin-right: 0;
  // Let clicks through the decorative gradient and padding reach the name cell.
  pointer-events: none;

  .MuiButtonGroup-root > * {
    // Keep buttons and disabled-button tooltip wrappers interactive.
    pointer-events: auto;
  }

  .MuiButtonGroup-root {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    box-shadow: none;
    background: linear-gradient(
      to right,
      transparent 0%,
      #ffd9c6 70%,
      #ffd9c6 100%
    );
    height: 40px;
    padding: 0 4.5px 0 9.5px;
    border-radius: 0 33px 33px 0;
  }

  .ag-row-hover & {
    visibility: visible;
  }
`;

export const RequisitionActionButton = styled.button<{ $isDisabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  border-radius: 50%;
  min-width: 32px;
  width: 32px;
  height: 32px;
  padding: 0;
  margin: 0;
  opacity: ${({ $isDisabled }) => ($isDisabled ? 0.5 : 1)};
  cursor: ${({ $isDisabled }) => ($isDisabled ? "default" : "pointer")};
  transition: background 0.15s ease-out;

  color: ${({ theme }) => theme.redMedium};

  svg path {
    fill: ${({ theme }) => theme.redMedium};
  }

  &:hover {
    background: ${({ $isDisabled }) =>
      $isDisabled ? "transparent" : "rgba(240, 96, 75, 0.8)"};
    color: ${({ $isDisabled, theme }) =>
      $isDisabled ? theme.redMedium : theme.white};

    svg path {
      fill: ${({ $isDisabled, theme }) =>
        $isDisabled ? theme.redMedium : theme.white};
    }
  }

  &:active {
    background: ${({ $isDisabled, theme }) =>
      $isDisabled ? "transparent" : theme.redDark};
    color: ${({ $isDisabled, theme }) =>
      $isDisabled ? theme.redMedium : theme.white};

    svg path {
      fill: ${({ $isDisabled, theme }) =>
        $isDisabled ? theme.redMedium : theme.white};
    }
  }
`;

export const RequisitionTooltipText = styled.div`
  margin-top: 4px;
  font-size: 14px;
  padding: 3px;
  white-space: nowrap;
`;
